import { render, staticRenderFns } from "./CMobile.vue?vue&type=template&id=50355990&scoped=true&"
import script from "./CMobile.vue?vue&type=script&lang=js&"
export * from "./CMobile.vue?vue&type=script&lang=js&"
import style0 from "./CMobile.vue?vue&type=style&index=0&id=50355990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50355990",
  null
  
)

export default component.exports